import React from 'react';

import {
  BACK,
  MASTER_READING,
  MASTER_READING_FIELDS,
  MASTER_READING_PAGES,
  MATCH_TICKETS,
} from './constants';
import { IconButton, TableCell, TextField } from '@material-ui/core';
import './MasterReading.css';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ErrorFeedbackBar from '../../global/ErrorFeedbackBar';
import { Layout } from '../../global/Table/TablePageHelpers/LayoutObject';
import TablePage from '../../global/Table/TablePage';
import { GetApp } from '@material-ui/icons';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import {
  DEFAULT_PDF_ZOOM,
  ROLE_OWNER,
  ROLE_MASTER_ADMIN,
  ROLE_MANAGER,
} from '../../global/constants';
import Utils from '../../Utils/Utils';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CustomToolbar from '../../global/CustomToolbar';
import withShipment from '../../../withShipment';
import {
  getMasterReadingPDFPreview,
  resetMasterReadingPdfPreviewData,
} from '../../../redux/actions/settings';
import { masterReadingPDFpreviewReadySelector } from '../../../redux/selectors/ticketOut';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Tooltip from '@material-ui/core/Tooltip';
import FilterIcon from '../../global/FilterIcon';
import PrintIcon from '@mui/icons-material/Print';

class MasterReadingTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: new Date(),
      selectedLocation: {},
      selectedLocationId: '',
      //report
      scale: DEFAULT_PDF_ZOOM,
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      fromDate: this.props.fromDate,
      toDate: this.props.toDate,
      isDialogOpen: false,
    };
  }

  componentDidMount() {}

  handleDialogOpen = () => {
    this.setState({ isDialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ isDialogOpen: false });
  };

  applyDateRange = () => {
    const { fromDate, toDate } = this.props;
    this.props.listSessionIds(fromDate, toDate, this.props.locationId);
    this.props.clearSessionId();
    this.props.clearReading();
    this.setState({ isDialogOpen: false });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.availableLocations !== this.props.availableLocations) {
      let findLocation = this.props.availableLocations.find(
        (location) =>
          location.shipAddressId === this.props.userInfo.selectedLocationId
      );
      let defaultLocation = findLocation ? findLocation : {};
      let selectedLocationId = defaultLocation?.shipAddressId;
      this.setState({
        selectedLocation: defaultLocation,
        selectedLocationId: selectedLocationId,
      });
    }

    if (
      !this.arrayEquals(prevProps.PDFpreviewReady, this.props.PDFpreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFpreviewReady,
      });
    }
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }
  showPdfErrorMessage = (isFailed) => {
    this.props.resetMatchPointPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.userInfo.firstname} Master Reading Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  fetchPdf = async () => {
    this.props.getMasterReadingPDFPreview(
      {
        sessionId: this.props.selectedSessionId,
        locationId: this.props.userInfo.selectedLocationId,
      },
      this.showPdfErrorMessage
    );
    this.setState({ showPdfViewer: true });
  };

  dateSelectRow = () => (
    <div className="width-100">
      <div className="session">
        <Autocomplete
          options={[...this.props.allSessionIds].sort(
            (a, b) => parseInt(a) - parseInt(b)
          )}
          getOptionLabel={(entry) => entry || ''} // Assuming the session IDs are strings
          autoHighlight={true}
          clearOnEscape
          onChange={(event, value) => {
            if (!value) {
              // Cleared (× or Escape) — drop the selected session and its readings.
              this.props.clearSessionId();
              this.props.clearReading();
            } else {
              this.props.handleSessionChange({ target: { value } }); // Pass the selected session ID to parent handler
            }
          }}
          blurOnSelect={true}
          filterOptions={(options, state) => options} // No filtering, show all session IDs
          value={this.props.selectedSessionId} // Use selected value from props or state
          renderInput={(params) => (
            <TextField
              {...params}
              label="Reading Session ID" // Updated label for session ID
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              name="sessionSelect" // Updated name for session ID
            />
          )}
        />
      </div>
    </div>
  );

  handleSave = () => {
    this.props.handleSave(this.state.templates);
  };

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null, null));
    MASTER_READING_FIELDS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, null, headCell.align));
    });
    return headers;
  };

  tableRow = (reading, index) => {
    const differenceClass =
      reading?.difference < 0 ? 'negative-difference' : 'positive-difference';
    return (
      <React.Fragment>
        <TableCell
          className="table-cell-left"
          style={{ width: '20px' }}
        ></TableCell>

        <TableCell className="table-cell-left">{reading?.machine}</TableCell>
        {/*<TableCell className="table-cell-left">{reading?.type} </TableCell>*/}
        {/*<TableCell className="table-cell-left">{reading?.game}</TableCell>*/}
        <TableCell className="table-cell-left">{reading?.prevIn}</TableCell>
        <TableCell className="table-cell-left">{reading?.prevOut}</TableCell>
        <TableCell className="table-cell-left">{reading?.curIn}</TableCell>
        <TableCell className="table-cell-left">{reading?.curOut}</TableCell>
        <TableCell style={{ textAlign: 'right' }}>{reading?.inValue}</TableCell>
        <TableCell style={{ textAlign: 'right' }}>
          {reading?.outValue}
        </TableCell>
        <TableCell
          style={{ textAlign: 'right' }}
          className={`${differenceClass}`}
        >
          {reading?.difference}
        </TableCell>
        <TableCell style={{ textAlign: 'right' }}>{reading?.lifePay}</TableCell>
        <TableCell
          style={{ textAlign: 'right' }}
          className={`${differenceClass}`}
        >
          {reading?.lifeHold}
        </TableCell>
      </React.Fragment>
    );
  };

  searchStrings = (reading) => {
    return [reading.game, reading.machine, reading.type];
  };

  render() {
    let headerButtons = [];

    if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            if (!this.state.pdfData) return;
            Utils.handlePdfAction(
              this.state.pdfData,
              'print',
              'Master-reading-report-print.pdf'
            );
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    } else {

        // Match Tickets + master-reading report both operate on a selected
        // session, so only surface them once a session is chosen.
        if (this.props.selectedSessionId) {
          headerButtons.push(
            {
              title: MATCH_TICKETS,
              icon: <JoinInnerIcon />,
              handler: () => {
                this.props.setCurrentPage(MASTER_READING_PAGES.MATCH_TICKETS, {});
              },
            },
            {
              title: 'View Report',
              icon: <VisibilityIcon />,
              handler: () => this.fetchPdf(),
            }
          );
        }

        const auth = this.props.userInfo?.authority || [];
        if (
          auth.includes(ROLE_OWNER) ||
          auth.includes(ROLE_MASTER_ADMIN) ||
          auth.includes(ROLE_MANAGER)
        ) {
          headerButtons.push({
            title: 'Audit Log',
            icon: <FactCheckIcon />,
            handler: () => {
              this.props.setCurrentPage(MASTER_READING_PAGES.AUDIT_LOG, {});
            },
          });
        }

    }

    const { showPdfViewer, pdfData } = this.state;

    return (
      <React.Fragment>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ErrorFeedbackBar />
          <CustomToolbar
            title={MASTER_READING}
            createTitle={MASTER_READING}
            backTitle={'Back To Menu'}
            onClick={() => {}}
            headerButtons={headerButtons}
          />
          {!showPdfViewer && this.dateSelectRow()}
        </MuiPickersUtilsProvider>

        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="date-range-dialog"
        >
          <DialogTitle id="date-range-dialog">Filters</DialogTitle>
          <DialogContent>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <div className="row-master-reading">
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="From Date"
                  format="yyyy-MM-dd"
                  value={this.props.fromDate}
                  onChange={(dateInput) => {
                    let date = new Date(dateInput?.toString());
                    if (date.toString() === 'Invalid Date') {
                      return;
                    }
                    this.props.handleFromDateChange(date);
                  }}
                />
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="To Date"
                  format="yyyy-MM-dd"
                  onChange={(dateInput) => {
                    let date = new Date(dateInput?.toString());
                    if (date.toString() === 'Invalid Date') {
                      return;
                    }
                    this.props.handleToDateChange(date);
                  }}
                  value={this.props.toDate}
                />
              </div>
            </MuiPickersUtilsProvider>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              onClick={this.handleDialogClose}
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              Cancel
            </Button>

            <Button
              autoFocus
              variant="contained"
              onClick={this.applyDateRange}
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              {' '}
              Apply
            </Button>
          </DialogActions>
        </Dialog>

        {showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={this.state.scale}
          />
        ) : (
          <div>
            <Tooltip title={'Filter'}>
              <IconButton
                style={{ marginLeft: '300px', marginTop: '40px' }}
                onClick={this.handleDialogOpen}
                // className="filterButton"
                size="small"
                aria-label={'Filter'}
              >
                <FilterIcon />
              </IconButton>
            </Tooltip>

            <div style={{ marginTop: '-60px' }} className="master-reading-nowrap-header">
              <TablePage
                tableName="masterReading"
                tableRows={this.props.readings}
                tableColumnHeads={this.getTableHeaders()}
                tableRow={this.tableRow}
                paginationText="Results"
                hasSearchField
                searchStrings={this.searchStrings}
              />
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  PDFpreviewReady: masterReadingPDFpreviewReadySelector(state),
});

const actionCreators = {
  getMasterReadingPDFPreview,
  resetMasterReadingPdfPreviewData,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  MasterReadingTable
);
